import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AccessTypeItem } from '../models/access-type-item.model';
import { StationAccessType } from '../models/station-access-type.model';
import { PlugTypeItem } from '../models/plug-type-item.model';
import { StationPlugType } from '../models/station-plug-type.model';
import { MaxPowerItem } from '../models/max-power-item.model';
import { OcppCommandTypeItem } from '../models/ocpp-command-type-item';
import { OcppCommandType } from '../models/ocpp-command-type';
import { AutoExportFormatterTypeItem } from '../models/autoexport/autoexport-formatter-type-item.model';
import { AutoExportFormatterType } from '../models/autoexport/autoexport-formatter-type.model';
import { AutoExportDestinationTypeItem } from '../models/autoexport/autoexport-destination-type-item.model';
import { AutoExportDestinationType } from '../models/autoexport/autoexport-destination-type.model';
import { ExportAmountTypeItem } from '../models/autoexport/autoexport-exportamount-type-item.model';
import { ExportAmountType } from '../models/autoexport/autoexport-exportamount-type.model';
import { AutoExportFormatterConfigurationIseMeteringIdentificationTypeItem } from '../models/autoexport/autoexport-formatter-configuration-ise-meteringidentification-type-item.model';
import { AutoExportFormatterConfigurationIseMeteringIdentificationType } from '../models/autoexport/autoexport-formatter-configuration-ise-meteringidentification-type.model';

@Injectable()
export class TypesService {
  constructor(public translate: TranslateService) { }

  getAccessTypes(): AccessTypeItem[] {
    let privateText = 'Private';
    this.translate
      .get(StationAccessType[StationAccessType.AccessTypePrivate])
      .subscribe((res: string) => {
        privateText = res;
      });

    let limitedText = 'Limited';
    this.translate
      .get(StationAccessType[StationAccessType.AccessTypeLimited])
      .subscribe((res: string) => {
        limitedText = res;
      });

    let publicText = 'Public';
    this.translate
      .get(StationAccessType[StationAccessType.AccessTypePublic])
      .subscribe((res: string) => {
        publicText = res;
      });

    const items = new Array<AccessTypeItem>();

    items.push(
      new AccessTypeItem(StationAccessType.AccessTypePrivate, privateText)
    );
    items.push(
      new AccessTypeItem(StationAccessType.AccessTypeLimited, limitedText)
    );
    items.push(
      new AccessTypeItem(StationAccessType.AccessTypePublic, publicText)
    );

    return items;
  }

  getPlugTypes(): PlugTypeItem[] {
    const items = new Array<PlugTypeItem>();

    items.push(new PlugTypeItem(StationPlugType.Unkown, 'Unknown'));
    items.push(new PlugTypeItem(StationPlugType.Type2, 'Type2'));
    items.push(new PlugTypeItem(StationPlugType.Schuko, 'Schuko'));
    items.push(new PlugTypeItem(StationPlugType.Swiss, 'Swiss'));
    items.push(new PlugTypeItem(StationPlugType.CHAdeMO, 'CHAdeMO'));
    items.push(new PlugTypeItem(StationPlugType.Uk, 'Uk'));
    items.push(new PlugTypeItem(StationPlugType.CCS, 'CCS'));

    return items;
  }

  getMaxPowerItems(): MaxPowerItem[] {
    const items = new Array<MaxPowerItem>();

    items.push(new MaxPowerItem(1800, '1.8 kW'));
    items.push(new MaxPowerItem(2300, '2.3 kW'));
    items.push(new MaxPowerItem(3700, '3.7 kW'));
    items.push(new MaxPowerItem(4600, '4.6 kW'));
    items.push(new MaxPowerItem(7400, '7.4 kW'));
    items.push(new MaxPowerItem(11000, '11 kW'));
    items.push(new MaxPowerItem(22000, '22 kW'));
    items.push(new MaxPowerItem(50000, '50 kW'));
    items.push(new MaxPowerItem(100000, '100 kW'));
    items.push(new MaxPowerItem(150000, '150 kW'));
    items.push(new MaxPowerItem(200000, '200 kW'));
    items.push(new MaxPowerItem(250000, '250 kW'));
    items.push(new MaxPowerItem(300000, '300 kW'));
    items.push(new MaxPowerItem(350000, '350 kW'));
    items.push(new MaxPowerItem(400000, '400 kW'));

    return items;
  }

  getOcppCommandTypeItems(): OcppCommandTypeItem[] {
    const items = new Array<OcppCommandTypeItem>();

    items.push(new OcppCommandTypeItem(OcppCommandType.AllowOfflineTxForUnknownId, 'AllowOfflineTxForUnknownId'));
    items.push(new OcppCommandTypeItem(OcppCommandType.AuthorizationCacheEnabled, 'AuthorizationCacheEnabled'));
    items.push(new OcppCommandTypeItem(OcppCommandType.AuthorizeRemoteTxRequests, 'AuthorizeRemoteTxRequests'));
    items.push(new OcppCommandTypeItem(OcppCommandType.BlinkRepeat, 'BlinkRepeat'));
    items.push(new OcppCommandTypeItem(OcppCommandType.ClockAlignedDataInterval, 'ClockAlignedDataInterval'));
    items.push(new OcppCommandTypeItem(OcppCommandType.ConnectionTimeOut, 'ConnectionTimeOut'));
    items.push(new OcppCommandTypeItem(OcppCommandType.GetConfigurationMaxKeys, 'GetConfigurationMaxKeys'));
    items.push(new OcppCommandTypeItem(OcppCommandType.HeartbeatInterval, 'HeartbeatInterval'));
    items.push(new OcppCommandTypeItem(OcppCommandType.LightIntensity, 'LightIntensity'));
    items.push(new OcppCommandTypeItem(OcppCommandType.LocalAuthorizeOffline, 'LocalAuthorizeOffline'));
    items.push(new OcppCommandTypeItem(OcppCommandType.LocalPreAuthorize, 'LocalPreAuthorize'));
    items.push(new OcppCommandTypeItem(OcppCommandType.MaxEnergyOnInvalidId, 'MaxEnergyOnInvalidId'));
    items.push(new OcppCommandTypeItem(OcppCommandType.MeterValuesAlignedData, 'MeterValuesAlignedData'));
    items.push(new OcppCommandTypeItem(OcppCommandType.MeterValuesAlignedDataMaxLength, 'MeterValuesAlignedDataMaxLength'));
    items.push(new OcppCommandTypeItem(OcppCommandType.MeterValuesSampledData, 'MeterValuesSampledData'));
    items.push(new OcppCommandTypeItem(OcppCommandType.MeterValuesSampledDataMaxLength, 'MeterValuesSampledDataMaxLength'));
    items.push(new OcppCommandTypeItem(OcppCommandType.MeterValueSampleInterval, 'MeterValueSampleInterval'));
    items.push(new OcppCommandTypeItem(OcppCommandType.MinimumStatusDuration, 'MinimumStatusDuration'));
    items.push(new OcppCommandTypeItem(OcppCommandType.NumberOfConnectors, 'NumberOfConnectors'));
    items.push(new OcppCommandTypeItem(OcppCommandType.ResetRetries, 'ResetRetries'));
    items.push(new OcppCommandTypeItem(OcppCommandType.ConnectorPhaseRotation, 'ConnectorPhaseRotation'));
    items.push(new OcppCommandTypeItem(OcppCommandType.ConnectorPhaseRotationMaxLength, 'ConnectorPhaseRotationMaxLength'));
    items.push(new OcppCommandTypeItem(OcppCommandType.StopTransactionOnEVSideDisconnect, 'StopTransactionOnEVSideDisconnect'));
    items.push(new OcppCommandTypeItem(OcppCommandType.StopTransactionOnInvalidId, 'StopTransactionOnInvalidId'));
    items.push(new OcppCommandTypeItem(OcppCommandType.StopTxnAlignedData, 'StopTxnAlignedData'));
    items.push(new OcppCommandTypeItem(OcppCommandType.StopTxnAlignedDataMaxLength, 'StopTxnAlignedDataMaxLength'));
    items.push(new OcppCommandTypeItem(OcppCommandType.StopTxnSampledData, 'StopTxnSampledData'));
    items.push(new OcppCommandTypeItem(OcppCommandType.StopTxnSampledDataMaxLength, 'StopTxnSampledDataMaxLength'));
    items.push(new OcppCommandTypeItem(OcppCommandType.SupportedFeatureProfiles, 'SupportedFeatureProfiles'));
    items.push(new OcppCommandTypeItem(OcppCommandType.SupportedFeatureProfilesMaxLength, 'SupportedFeatureProfilesMaxLength'));
    items.push(new OcppCommandTypeItem(OcppCommandType.TransactionMessageAttempts, 'TransactionMessageAttempts'));
    items.push(new OcppCommandTypeItem(OcppCommandType.TransactionMessageRetryInterval, 'TransactionMessageRetryInterval'));
    items.push(new OcppCommandTypeItem(OcppCommandType.UnlockConnectorOnEVSideDisconnect, 'UnlockConnectorOnEVSideDisconnect'));
    items.push(new OcppCommandTypeItem(OcppCommandType.WebSocketPingInterval, 'WebSocketPingInterval'));
    items.push(new OcppCommandTypeItem(OcppCommandType.LocalAuthListEnabled, 'LocalAuthListEnabled'));
    items.push(new OcppCommandTypeItem(OcppCommandType.LocalAuthListMaxLength, 'LocalAuthListMaxLength'));
    items.push(new OcppCommandTypeItem(OcppCommandType.SendLocalListMaxLength, 'SendLocalListMaxLength'));
    items.push(new OcppCommandTypeItem(OcppCommandType.ReserveConnectorZeroSupported, 'ReserveConnectorZeroSupported'));
    items.push(new OcppCommandTypeItem(OcppCommandType.ChargeProfileMaxStackLevel, 'ChargeProfileMaxStackLevel'));
    items.push(new OcppCommandTypeItem(OcppCommandType.ChargingScheduleAllowedChargingRateUnit, 'ChargingScheduleAllowedChargingRateUnit'));
    items.push(new OcppCommandTypeItem(OcppCommandType.ChargingScheduleMaxPeriods, 'ChargingScheduleMaxPeriods'));
    items.push(new OcppCommandTypeItem(OcppCommandType.ConnectorSwitch3to1PhaseSupported, 'ConnectorSwitch3to1PhaseSupported'));
    items.push(new OcppCommandTypeItem(OcppCommandType.MaxChargingProfilesInstalled, 'MaxChargingProfilesInstalled'));
    items.push(
      new OcppCommandTypeItem(OcppCommandType.MaxTxMeterValueRandomisationTime, '(Alfen ICU) MaxTxMeterValueRandomisationTime', 'Alfen ICU')
    );
    items.push(
      new OcppCommandTypeItem(OcppCommandType.StrictPEMeasurementEnabled, '(Alfen ICU) StrictPEMeasurementEnabled', 'Alfen ICU')
    );

    return items;
  }

  getAutoExportFormatterTypes(): AutoExportFormatterTypeItem[] {
    const items = new Array<AutoExportFormatterTypeItem>();

    let ise = this.translate.instant('autoexport.formatter.ise');
    items.push(new AutoExportFormatterTypeItem(AutoExportFormatterType.Ise, ise));

    return items;
  }

  getAutoExportDestinationTypes(): AutoExportDestinationTypeItem[] {
    const items = new Array<AutoExportDestinationTypeItem>();

    let ftps = this.translate.instant('autoexport.destination.ftps');
    items.push(new AutoExportDestinationTypeItem(AutoExportDestinationType.Ftps, ftps));

    let sftp = this.translate.instant('autoexport.destination.sftp');
    items.push(new AutoExportDestinationTypeItem(AutoExportDestinationType.Sftp, sftp));

    return items;
  }

  getExportAmountTypes(): ExportAmountTypeItem[] {
    const items = new Array<ExportAmountTypeItem>();

    let day = this.translate.instant('autoexport.job.exportamount.day');
    items.push(new ExportAmountTypeItem(ExportAmountType.Day, day));

    let week = this.translate.instant('autoexport.job.exportamount.week');
    items.push(new ExportAmountTypeItem(ExportAmountType.Week, week));

    let month = this.translate.instant('autoexport.job.exportamount.month');
    items.push(new ExportAmountTypeItem(ExportAmountType.Month, month));

    let year = this.translate.instant('autoexport.job.exportamount.year');
    items.push(new ExportAmountTypeItem(ExportAmountType.Year, year));

    return items;
  }

  getAutoExportFormatterConfigurationIseMeteringIdentificationTypes():
    AutoExportFormatterConfigurationIseMeteringIdentificationTypeItem[] {
    const items = new Array<AutoExportFormatterConfigurationIseMeteringIdentificationTypeItem>();

    items.push(new AutoExportFormatterConfigurationIseMeteringIdentificationTypeItem(
      AutoExportFormatterConfigurationIseMeteringIdentificationType.DeviceLocationId, 'DeviceLocationId'));
    items.push(new AutoExportFormatterConfigurationIseMeteringIdentificationTypeItem(
      AutoExportFormatterConfigurationIseMeteringIdentificationType.FactoryNo, 'FactoryNo'));
    items.push(new AutoExportFormatterConfigurationIseMeteringIdentificationTypeItem(
      AutoExportFormatterConfigurationIseMeteringIdentificationType.InternalNo, 'InternalNo'));
    items.push(new AutoExportFormatterConfigurationIseMeteringIdentificationTypeItem(
      AutoExportFormatterConfigurationIseMeteringIdentificationType.MeteringCode, 'MeteringCode'));

    return items;
  }
}
